<template>
    <div>
        <div class="order-section">
            <h2 class="order-section__heading">
                1. An welche PLZ soll geliefert werden?
            </h2>
            <div class="form-default">
                <label for="postal-code" class="control-label">
                    <span class="label-text">
                        PLZ
                    </span><span class="required-symbol"><span class="sr-only" lang="en">(Pflichtfeld)</span></span>
                </label>
                <div class="d-flex align-items-center">
                    <input
                        id="postal-code"
                        v-model="postalCode"
                        class="form-control zip-code"
                        name="postal-code"
                        type="zipcode"
                        minlength="4"
                        maxlength="4"
                        required
                    >
                    <span v-if="postalCodeComplete && isValidPostalCode" class="icomoon-check" />
                </div>
            </div>

            <p v-if="showPostalCodeRequiredHint && !postalCodeComplete" class="order-section__required-hint">Bitte eine gültige PLZ eingeben.</p>
            <p v-if="postalCodeComplete && !isValidPostalCode" class="order-section__description">Deine PLZ ist leider noch nicht in unserem Liefergebiet. Du kannst mit der Bestellung trotzdem fortfahren – wir melden uns danach bei dir.</p>
        </div>

        <div class="order-section">
            <h2 v-if="mode==='private'" class="order-section__heading">
                2. Wähle deinen Basis-Korb
            </h2>
            <h2 v-else class="order-section__heading">
                2. Wählt euren Basis-Korb
            </h2>

            <subscription-types />
        </div>

        <div class="order-section">

            <h2 v-if="mode==='private'" class="order-section__heading">
                3. Wie gross ist dein Haushalt?
            </h2>
            <h2 v-else class="order-section__heading">
                3. Wie gross ist euer Appetit?
            </h2>

            <div
                class="order-step-2"
            >
                <div class="order-step-2__col-container">

                    <people
                        :min="1"
                        :max="mode==='private' ? 10 : 50"
                    />

                    <appetite
                        v-if="mode==='business'"
                    />
                    <appetite-private v-else />
                </div>
                <div class="order-step-2-variation__details-col-container">
                    <div class="order-step-2-variation__details-col order-step-2-variation__details-col-1">
                        <a
                            v-if="mode === 'private'"
                            href="#"
                            class="order-step-2-variation__info-link"
                            @click.prevent="toggleInfoModalVisible(`Nach den Empfehlungen der Schweizerischen Gesellschaft für Ernährung sollte eine erwachsene Person täglich 5 Portionen Früchte und Gemüse in verschiedenen Farben zu sich nehmen. Unsere Liefermengen sind so berechnet, dass du täglich mit 1 bis 2 Portionen Früchte oder Gemüse versorgt wirst. Somit deckt der Öpfelchasper 20 bis 40 % deines Bedarfs an Rohkost.`)"
                        >
                            Mengenangaben
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <results v-if="mode==='business'"/>
        <results-private v-else/>

    </div>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line
import { mapState } from 'vuex';
import { validate, search } from 'swiss-zipcodes';

import SubscriptionTypes from './SubscriptionTypes.vue';
import People from './People.vue';
import Appetite from './Appetite.vue';
import AppetitePrivate from './AppetitePrivate.vue';
import Amounts from './Amounts.vue';
import Results from './Results.vue';
import ResultsPrivate from './ResultsPrivate.vue';

// The v3 products API requires a zip in the URL path. Until a PLZ is
// entered the catalog is fetched with a fixed zip - products, prices and
// delivery fee are identical for every zip, only is_on_request (the
// 'not in delivery area' notice) differs.
const DEFAULT_ZIP = '8004';

export default {
    components: {
        SubscriptionTypes,
        People,
        Appetite,
        AppetitePrivate,
        Amounts,
        Results,
        ResultsPrivate,
    },
    data() {
        return {
            postalCode: this.$store.state.postalCode || '',
            showPostalCodeRequiredHint: false,
        };
    },
    computed: {
        ...mapState({
            mode: state => state.mode,
            editModeVisible: state => state.editModeVisible,
            subscriptionType: state => state.subscriptionType,
            subscriptionTypes: state => state.orderable.product_groups,
            isValidPostalCode: state => state.isValidPostalCode,
        }),
        postalCodeComplete() {
            return /^\d{4}$/.test(this.postalCode);
        },
    },
    watch: {
        postalCode() {
            this.checkPostalCode();
        },
    },
    mounted() {
        $('#order-header, #order-description, #order-disturber--footer, .hamburger').removeClass('hidden');
        $('#order-disturber--header').remove();

        // re-enable brand logo link
        $('.brand-logo__link').attr('href', $('.brand-logo__link').data('href'));

        if (this.postalCodeComplete) {
            this.checkPostalCode();
        } else {
            this.fetchOrderable(DEFAULT_ZIP);
        }
    },
    methods: {
        toggleInfoModalVisible(content) {
            this.$store.commit('toggleInfoModalVisible', content);
        },
        checkPostalCode() {
            if (!this.postalCodeComplete) {
                return;
            }
            let city = '';

            if (validate(this.postalCode)) {
                const getCity = search({ zip: parseInt(this.postalCode, 10) });
                city = getCity[0].commune;
            }

            this.$store.commit('setPostalCode', { zip: this.postalCode, city });
            this.fetchOrderable(this.postalCode);
        },
        validatePostalCode() {
            this.showPostalCodeRequiredHint = !this.postalCodeComplete;
            return this.postalCodeComplete;
        },
        fetchOrderable(zip) {
            const route = this.$router.options.base.split('/')[1];
            if (this.mode === 'private') {
                this.$store.dispatch('fetchOrderablePrivate', { id: zip, lang: route }).then(() => {
                    this.$store.dispatch('resetOrderPLZ');
                });
            } else {
                this.$store.dispatch('fetchOrderableBusiness', { id: zip, lang: route }).then(() => {
                    this.$store.dispatch('resetOrderPLZ');
                });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// Order.vue?210dea20